export default (api, resource) => ({

    /*
      Aparelhos ligados no codigo de TV da regiao -- as instalacoes que nao
      pertencem a nenhum ponto.
    */
    getInstalacoes: async ({ id, token }) => {
        const response = await api.get(`/${resource}/${id}/instalacoes`, {
            headers: { Authorization: token }
        })

        return { data: response.data }
    },

    create: async ({region, token}) => {

        const response = await api.post(`bingo/regiao`, region, {
          headers: {
              Authorization: token
            } 
        })

        return {
          data: response.data
        }
        
    },

    getAll: async ({ params, token }) => {
	
        const response = await api.get(`/${resource}?pagina=${params.pagina}&quantidade=${params.quantidade}`, {
          headers: {
              Authorization: token
            } 
        })
        
        return {
          data: response.data
        }

    },

    
    update: async ({region, token}) => {
      
        const response = await api.put(`/${resource}/${region.id}`, region, {
          headers: {
              Authorization: token
            } 
        })

        return {
          data: response.data
        }
    },


	getGestor: async ({region, token}) =>{
		const response = await api.get(`${resource}/pesquisa/${region.id}`,{
			headers: {
				Authorization: token
			}
		})

		return {
			data: response.data
		}
	}

})